import { FC } from 'react';
import ProSteps, { StepsProps } from './steps';
import ProStep, { StepProps } from './step';

export type IStepsComponent = FC<
  StepsProps & React.RefAttributes<HTMLElement>
> & {
  Step: FC<StepProps & React.RefAttributes<HTMLElement>>;
};

const TransSteps = ProSteps as IStepsComponent;
TransSteps.Step = ProStep;

export default TransSteps;
